import axiosApi from '../../axiosApi'

// initial state
const state = {
  accountInfo: {},
  product: []
}

// getters
const getters = {
  getAccountInfo: (state) => {
    return state.accountInfo
  }
}

// actions
const actions = {
  // deleteAccount ({commit, state}, payload) {
  //   return axiosApi.post(`/users/deleteAccount`, payload)
  //     .then(response => {
  //       return response.data
  //     }).catch(e => {
  //       return e.response
  //     })
  // },
  deleteAccount ({commit, state}, payload) {
    return axiosApi.post(`/users/deleteAccount`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  accountInfo ({commit, state}, payload) {
    return axiosApi.get(`/users/accountInfo/${payload.userId}`, payload)
      .then(response => {
        commit('setAccountData', response.data)
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  companyInfo ({commit, state}, payload) {
    return axiosApi.get(`/users/companyInfo/${payload.userId}`, payload)
      .then(response => {
        commit('setAccountData', response.data)
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  accountVisibility ({commit, state}, payload) {
    return axiosApi.post(`/user/accountVisibility`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  whoCanSeeAccount ({commit, state}, payload) {
    return axiosApi.post(`/whoCanSeeAccount`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  individualFriend ({commit, state}, payload) {
    return axiosApi.post(`/showAccountForFriend`, payload)
      .then(response => {
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  getProductsRequestsByUserId ({commit, state}, payload) {
    return axiosApi.get(`/product/getProductWithRequestsByUserId/${payload.userId}`)
      .then(response => {
        commit('setUserProductsRequests', response.data)
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  clearAccountInfo ({commit, state}, payload) {
    commit('setAccountData', payload)
  }
}

// mutations
const mutations = {
  setAccountData (state, accountInfo) {
    state.accountInfo = accountInfo
  },
  setUserProductsRequests (state, product) {
    state.product = product
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js